import React from 'react';
import {Header, Footer} from '../../common'


/* This component component contains the common structure and layout elements, such as headers, footers and other elements that are consistent across the pages.*/

function LayoutMain ({ children, showHeader = true, showFooter = true }) {
    return (
      <div className='layout-main'>
        {showHeader && <Header />}
        <main className="layout-container">
            {children}
            </main>
        {showFooter && <Footer />}
      </div>
    );
  };

  export default LayoutMain; 
  